/**
 * MarketingConsentCheckbox — v146.44 (Feb 2026)
 *
 * Tiny opt-in tick shown right below every visitor phone-input field.
 * Default checked (the brand needs implicit-yes to broadcast) but the
 * visitor can un-check to opt out. State bubbles up via `onChange` so
 * the parent form can ship it inside the lead/order/review payload
 * under the `marketing_consent` key.
 *
 * Kept intentionally microscopic — one line of copy, small text — so
 * it never dominates a form. Meta-approved marketing template will
 * still ship an unsubscribe cue in its own footer, this is the *opt-
 * in* signal at capture time.
 */
import { Check } from "lucide-react";

export default function MarketingConsentCheckbox({
  checked = true,
  onChange,
  testid = "marketing-consent",
  brandName,
  className = "",
  compact = false,
}) {
  return (
    <label
      className={`flex items-start gap-1.5 text-[11px] leading-snug cursor-pointer select-none ${className}`}
      data-testid={testid}
    >
      <input
        type="checkbox"
        checked={!!checked}
        onChange={(e) => onChange && onChange(e.target.checked)}
        data-testid={`${testid}-input`}
        className="mt-[2px] w-3.5 h-3.5 accent-current shrink-0"
      />
      <span className="opacity-80">
        {compact
          ? `Send me offers${brandName ? ` from ${brandName}` : ""} on WhatsApp.`
          : `Yes, send me offers${brandName ? ` from ${brandName}` : ""} on WhatsApp. Reply STOP any time to unsubscribe.`}
      </span>
    </label>
  );
}

/** Convenience icon variant if a caller wants a green tick badge. */
export function ConsentBadge() {
  return <Check className="w-3 h-3" strokeWidth={3} />;
}
